import { ref, computed, watch } from 'vue'
import { storeToRefs } from 'pinia'

import { useMutation } from '@tanstack/vue-query'

import { useGameState } from '@/stores/gameState'

export const useInHandActions = () => {
  const { totalPot, isMyTurn } = storeToRefs(useGameState())
  const { bet: betOp, fold: foldOp, call: callOp, raise: raiseOp, check: checkOp } = useGameState()

  // perform action allowed only once
  const isActionPerformed = ref(false)
  function onActionPerfomed() {
    isActionPerformed.value = true
  }

  watch(isMyTurn, () => {
    isActionPerformed.value = false
  })

  const { mutate: bet } = useMutation({
    mutationFn: betOp,
    onMutate: onActionPerfomed
  })
  const { mutate: raise } = useMutation({
    mutationFn: raiseOp,
    onMutate: onActionPerfomed
  })
  const { mutate: fold } = useMutation({
    mutationFn: foldOp,
    onMutate: onActionPerfomed
  })
  const { mutate: call } = useMutation({
    mutationFn: callOp,
    onMutate: onActionPerfomed
  })
  const { mutate: check } = useMutation({
    mutationFn: checkOp,
    onMutate: onActionPerfomed
  })

  return {
    isPending: isActionPerformed,
    totalPot,
    bet,
    fold,
    call,
    check,
    raise
  }
}
